// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
enum ExternalReportType {
  Cso = "CSO",
  Mof = "MOF",
  Mot = "MOT",
}
export default ExternalReportType;
